import astm from './Astm/Config';
import aashto from './Aashto/Config';
import As from './As/Config';
import bseniso from './BsEnIso/Config';

export default {
  ...As,
  ...astm,
  ...aashto,
  ...bseniso,
};
